import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

const SideBarPost = () => {
    const [recent, setRecent] = useState(null);
    const getRecentTopics = () => {
        axios.get(`https://buzzinguniverse.com/backend/api/get-recent-topic-request`).then(function(res){
            setRecent(res.data.data);
        })
    }

    useEffect(() => {
        getRecentTopics()
    }, [])

    if(!recent){
        return false;
    }
    return (
        <>
            <div className="widget_display_topics">
                <h5 className="widget-title">Recent Topics</h5>
                <ul className="bbp-topics-widget newness">
                    {
                        recent.map((r) => (
                            <li><Link className="bbp-forum-title" to={`/forums/${r.forum_id}/topics/${r.id}`}>{r.title}</Link></li>
                        ))
                    }
                </ul>
            </div>
            
            <ul className="aside-navbar">
                <li><Link to="/activity">Home</Link></li>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/faqs">FAQs</Link></li>
                <li><Link to="/forums">Forums</Link></li>
                <li><Link to="/contact">Contact</Link></li>
            </ul>
        </>
    )
}

export default SideBarPost
